var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup3Updated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95579 23L5.21479 20.5357L11.3418 17.25L11.6871 13.9643L1.89947 4.92857L2.24481 1.64286H7.2005L7.37317 0H14.8067H22.2403L22.0676 1.64286H27.0233L26.6779 4.92857L14.9909 13.9643L14.6456 17.25L20.0819 20.5357L19.8229 23H12.3893H4.95579ZM7.85378 3.28571H4.54999L4.46365 4.10714L7.50844 6.57143L7.85378 3.28571ZM21.069 3.28571H24.3728L24.2864 4.10714L20.7236 6.57143L21.069 3.28571Z",
    fill: "#E77238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4094 1.65137C15.9867 1.65137 16.6063 2.62309 16.4514 3.97504L16.3669 4.77776C16.2683 5.60865 15.8458 6.04522 15.1276 6.25647C15.9585 6.48179 16.212 7.15777 16.1134 8.04499L15.9726 9.38286C15.8599 10.5658 15.1417 11.4249 13.6066 11.4249C11.9589 11.4249 11.3252 10.4109 11.4801 9.00262L11.6069 7.7915L13.0715 7.7915L12.9307 9.14345C12.8743 9.70677 13.0574 10.087 13.6348 10.087C14.1277 10.087 14.3249 9.81943 14.3812 9.25612L14.5502 7.65067C14.6065 7.14369 14.4235 6.87611 13.8601 6.87611L13.1701 6.87611L13.2968 5.6509L13.8601 5.6509C14.4235 5.6509 14.7896 5.38333 14.8459 4.80593L14.9445 3.84829C15.0008 3.29906 14.8178 2.98924 14.3108 2.98924C13.8038 2.98924 13.5785 3.25681 13.5221 3.82013L13.4095 4.89043L11.9449 4.89043L12.0575 3.83421C12.1843 2.52451 12.8462 1.65137 14.4094 1.65137Z",
    fill: "#161C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup3Updated);
export default __webpack_public_path__ + "static/media/cup-3-updated.85d7535ddae9697158f3d2f78371c727.svg";
export { ForwardRef as ReactComponent };